module.exports = __webpack_public_path__ + "static/media/hiring-banner-01.a227e6bf.png";